export default "__VITE_ASSET__CGH826yY__"